import {
  Box,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
  useMediaQuery,
  createStandaloneToast,
} from "@chakra-ui/react";
import React, { FC } from "react";
import { Button } from "./Button";
import { useUser } from "./UserContext";
import { CloseIcon } from "./CloseIcon";
import { SUCCESS_TOAST_DURATION } from "../common";

const toast = createStandaloneToast();

export const DeleteAccountButton: FC<{}> = (props) => {
  const { user } = useUser();
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const typeFormParams = {
    first_name: user.pulpoUser.name,
    email: user.pulpoUser.email,
    uid: user.pulpoUser.uid,
  };
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent
          maxWidth={["100%", "100%", "100%", "60%"]}
          height={["100%", "100%", "100%", "700px"]}
          top="0"
          margin={["0", "0", "8", "8"]}
          paddingX="0"
          paddingY="0"
          background="transparent"
        >
          <CloseIcon
            onClick={() => {
              onClose();
              toast({
                title: "Solicitud recibida",
                description:
                  "Hemos recibido su solicitud de eliminación de cuenta. Nuestro equipo se pondrá en contacto contigo pronto",
                status: "success",
                duration: SUCCESS_TOAST_DURATION,
                isClosable: true,
              });
            }}
            position="absolute"
            right="15px"
            top="15px"
            w={["30px", "30px", "52px", "52px"]}
            h={["30px", "30px", "52px", "52px"]}
          />
          <Box
            as="iframe"
            src={`https://pulp0.typeform.com/to/qC9qAboX#${new URLSearchParams(
              typeFormParams
            )}`}
            title="Darse de baja"
            width="100%"
            height="100%"
            borderRadius={["0", "0", "30px", "30px"]}
            background="#fff"
          />
        </ModalContent>
      </Modal>
      <Button
        size={isLargerThan900 ? "md" : "sm"}
        width="100%"
        variant="pulpo"
        colorScheme="pulpoDarkGray"
        onClick={onOpen}
      >
        <Text textStyle="button" color="#7E8897">
          Eliminar Cuenta
        </Text>
      </Button>
    </>
  );
};
